import { Icon, IconProps } from "../";

export const SendLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M2.35059 2.36522C2.56873 2.22796 2.84185 2.21272 3.07422 2.32421L21.3555 11.0986C22.1112 11.4618 22.1112 12.5382 21.3555 12.9014L3.07422 21.6758C2.84185 21.7873 2.56873 21.772 2.35059 21.6348C2.1324 21.4975 2 21.2578 2 21V14.25C2 13.9118 2.22644 13.6153 2.55273 13.5264L8.14941 12L2.55273 10.4736C2.22644 10.3846 2 10.0882 2 9.74999V2.99999C2 2.74221 2.1324 2.50251 2.35059 2.36522ZM3.5 9.17675L11.1973 11.2764C11.5236 11.3653 11.75 11.6618 11.75 12C11.75 12.3382 11.5236 12.6346 11.1973 12.7236L3.5 14.8223V19.8076L19.7656 12L3.5 4.1914V9.17675Z" />
    </Icon>
  );
};
